module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/Avietchii/Kanagawa_Avietchii_GFDL_RCP45_End.png";